export default "__VITE_ASSET__CcooJ3Mx__"